import { useFlags } from '~/hooks/use-flags';
import { LDFlags } from '~/providers/launch-darkly';
import { IS_TEST } from '~/utils/constants';

export const usePenguinHealth = () => {
  const maintenanceModeEnabled = useFlags(LDFlags.maintenanceModeEnabled);

  return { isMaintenance: maintenanceModeEnabled && !IS_TEST };
};
